module.exports = __webpack_public_path__ + "img/icon-towel-rail.a4348895.svg";